import React, { useEffect, useState } from "react";
import { Waveform } from "@phosphor-icons/react";

const LOGO_URL = "https://flowscribe.com/wp-content/uploads/2014/01/logo_horizontal_web.png";

/**
 * Flowscribe logo. Uses the official horizontal PNG. If the image can't
 * load within a few seconds (offline, CORS, etc.) we switch to the wordmark
 * + waveform icon so the header never stays blank.
 */
export default function Logo({ className = "h-8", variant = "color", testId = "brand-logo" }) {
  const [state, setState] = useState("loading"); // "loading" | "loaded" | "failed"

  // Hard timeout — don't let a slow network leave the header empty
  useEffect(() => {
    if (state !== "loading") return undefined;
    const t = setTimeout(() => {
      setState((s) => (s === "loading" ? "failed" : s));
    }, 4000);
    return () => clearTimeout(t);
  }, [state]);

  if (state === "failed") {
    return (
      <span className="flex items-center gap-3" data-testid={`${testId}-fallback`}>
        <span className={`${variant === "inverse" ? "bg-white text-[--accent]" : "bg-[--accent] text-white"} w-8 h-8 grid place-items-center`}>
          <Waveform weight="bold" size={16} />
        </span>
        <span className="font-display font-black tracking-tighter text-lg">FLOWSCRIBE</span>
      </span>
    );
  }

  return (
    <img
      src={LOGO_URL}
      alt="Flowscribe"
      onLoad={() => setState("loaded")}
      onError={() => setState("failed")}
      data-testid={testId}
      className={`${className} w-auto ${variant === "inverse" ? "brightness-0 invert" : ""} ${state === "loading" ? "opacity-0" : ""}`}
      loading="eager"
      referrerPolicy="no-referrer"
    />
  );
}
